import { render, staticRenderFns } from "./settingsClickCollect.vue?vue&type=template&id=1b8b57fc&scoped=true&"
import script from "./settingsClickCollect.vue?vue&type=script&lang=js&"
export * from "./settingsClickCollect.vue?vue&type=script&lang=js&"
import style0 from "./settingsClickCollect.vue?vue&type=style&index=0&id=1b8b57fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8b57fc",
  null
  
)

export default component.exports